import { render, staticRenderFns } from "./pdfh5.vue?vue&type=template&id=4b2e0c77&"
import script from "./pdfh5.vue?vue&type=script&lang=js&"
export * from "./pdfh5.vue?vue&type=script&lang=js&"
import style0 from "./pdfh5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports